export const OUTCOMES = [["opfyldt", "Opfyldt", "bg-[#5f6b4a] text-white"], ["delvist", "Delvist", "bg-[#8A6D3B] text-white"], ["ikke_opfyldt", "Ikke opfyldt", "bg-[#A83232] text-white"]];
export const OUTCOME_LABEL = { opfyldt: "Opfyldt", delvist: "Delvist opfyldt", ikke_opfyldt: "Ikke opfyldt" };
export const OUTCOME_BADGE = { opfyldt: "bg-[#E7EADF] text-[#5f6b4a]", delvist: "bg-[#EFE7DC] text-[#8A6D3B]", ikke_opfyldt: "bg-[#F1DEDA] text-[#A83232]" };

export function OutcomePicker({ value, onChange, testid = "goal-outcome", size = "sm" }) {
  return (
    <div data-testid={testid}>
      <p className="text-xs font-medium text-stone-600 mb-1">Udfald (kræves ved lukning)</p>
      <div className="inline-flex rounded-lg border border-[#EBE8E3] p-0.5 flex-wrap">
        {OUTCOMES.map(([v, l, cls]) => <button key={v} type="button" onClick={() => onChange(v)} data-testid={`${testid}-${v}`} className={`px-2.5 py-1 rounded ${size === "sm" ? "text-xs" : "text-sm"} ${value === v ? cls : "text-stone-600"}`}>{l}</button>)}
      </div>
    </div>
  );
}

export function OutcomeBadge({ goal, testid }) {
  if (goal.status !== "Lukket") return null;
  const o = goal.outcome;
  return <span className={`text-[11px] px-2 py-0.5 rounded-full ${o ? OUTCOME_BADGE[o] : "bg-[#F0EDE8] text-stone-500"}`} data-testid={testid}>{o ? OUTCOME_LABEL[o] : "Udfald ikke angivet"}</span>;
}
